import type {AxiosRequestConfig} from 'axios';
//interfaces

export class FetchBasalamProductsRequestBuilder {
  private readonly tpsRequest: AxiosRequestConfig = {
    method: 'POST',
    url: `/tps-management/products/fetch`,
    data: {},
  };

  data(data: any) {
    this.tpsRequest.data = data;
    return this;
  }

  build() {
    return this.tpsRequest;
  }
}

export class FetchTpsFailedOrder {
  private readonly tpsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/tps-management/orders/failed',
    params: {}
  };

  params(params: any) {
    this.params = params
    return this;
  }

  build() {
    return this.tpsRequest;
  }
}

export class FetchRegistrationTimes {
  private readonly tpsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/tps-management/orders/time',
  };

  build() {
    return this.tpsRequest;
  }
}

export class RetryFailedOrder {
  private readonly tpsRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/tps-management/orders/retry',
    params: {},
  };

  params(params: any) {
    this.tpsRequest.params = params;
    return this;
  }

  build() {
    return this.tpsRequest;
  }
}
